import { useFiltersStore } from '../stores';
import { MEDIUM_TAGS, ON_VIEW_TAGS } from '../util/data-factory';

/**
 * Quick filter chips beside the filter icon (same behavior as showrunner-mobile FeedHeaderPills).
 * Tag labels come from Supabase `tags` (categories home filter NY / home filter LA).
 */
const FeedHeaderPills = ({ homeFilters, locationOptions, typeOptions }) => {
  const filterState = useFiltersStore();
  const { addToFilter, removeFromFilter } = filterState;

  const resolveFilterKeyForValue = value => {
    if (locationOptions.includes(value)) {
      return 'selectedLocation';
    }
    if (MEDIUM_TAGS.includes(value)) {
      return 'selectedMediums';
    }
    if (ON_VIEW_TAGS.includes(value)) {
      return 'open';
    }
    if (typeOptions.includes(value)) {
      return 'showType';
    }
    return 'open';
  };

  const handlePillPress = value => {
    const filterKey = resolveFilterKeyForValue(value);
    const selectedFilter = useFiltersStore.getState()[filterKey];

    if (selectedFilter.has(value)) {
      removeFromFilter(filterKey, value);
    } else {
      addToFilter(filterKey, value);
    }
  };

  const isPillSelected = value => {
    const filterKey = resolveFilterKeyForValue(value);
    return filterState[filterKey].has(value);
  };

  if (!homeFilters.length) {
    return null;
  }

  return (
    <div className="flex flex-nowrap gap-1.5 overflow-x-auto py-1 no-scrollbar">
      {homeFilters.map(value => {
        const selected = isPillSelected(value);
        return (
          <button
            key={value}
            type="button"
            onClick={() => handlePillPress(value)}
            className={`shrink-0 rounded-full px-4 py-2 text-sm font-bold transition-colors ${
              selected ? 'bg-secondary-red text-white' : 'bg-white text-gray-700 shadow-sm'
            }`}
          >
            {value}
          </button>
        );
      })}
    </div>
  );
};

export default FeedHeaderPills;
